import { Directive, ElementRef, HostListener, Renderer2 } from "@angular/core";
import { HoverboxService } from "app/core/services/hoverbox.service";

@Directive({
  selector: "[appHoverbox]",
})
export class HoverboxDirective {
  public hoveredClass: string = "hovered";
  public cursorPos: {
    x: number;
    y: number;
  } = {
    x: 0,
    y: 0,
  };

  constructor(
    private el: ElementRef,
    private renderer2: Renderer2,
    private hoverboxService: HoverboxService,
  ) {}

  @HostListener("mousemove", ["$event"])
  public onMousemove(event: MouseEvent): void {
    this.cursorPos = { x: event.clientX, y: event.clientY };
    this.hoverboxService.cursorPos$.next(this.cursorPos);
  }

  @HostListener("mouseenter")
  public onMouseEnter(): void {
    this.toggleClass(true);
  }

  @HostListener("mouseleave")
  public onMouseLeave(): void {
    this.toggleClass(false);
  }

  private toggleClass(classState: boolean): void {
    if (classState) {
      this.renderer2.addClass(this.el.nativeElement, this.hoveredClass);
    } else {
      this.renderer2.removeClass(this.el.nativeElement, this.hoveredClass);
    }
  }
}
